import S from 'common/service/sanctuary';
import { combineEpics, ofType } from 'redux-observable';
import { map } from 'rxjs/operators';

import {
  LOAD_CRITERIA,
  APPLY_CRITERIA,
  REMOVE_CRITERIA,
  CLEAR,
} from './actions';

import {
  getDSL,
} from './selectors';

const syncCriteriaEpic = (action, state) => action.pipe(
  ofType(LOAD_CRITERIA, APPLY_CRITERIA, REMOVE_CRITERIA, CLEAR),
);

export default combineEpics(
  syncCriteriaEpic,
);
